let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .btn.confirm" : '_checkPassword',
            "click .btn.cancel" : '_cancelCheckPassword'
        },
        _cancelCheckPassword: function() {
            this.model.trigger('cancel');
        },
        _checkPassword: function() {
            var self = this,password = $('.passwordEntryView input[type="password"]').val();
            console.log(self.$('.passwordEntryView input[type="password"]'));
            if(!password || typeof password == 'undefine'){
                alert("管理员输入密码确认");
                return false;
            }
            var result = $.post('/pos/checkPwd',
                {username: $('.adminSelect option:selected').text(), password:password});

            result.done(function(res) {
                console.log('result', res);
                if(res.success) {
                    self.model.trigger('confirm');
                } else {
                    $('.passwordEntryView .error').text("用户名密码不正确！");
                }
            });

            result.fail(function(res) {
                console.log('result', res);
                alert("无法连接朵颐服务器, 请稍后再试");
            });

        }
    });
};

let exportedValue = main();
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/view/comp/PasswordEntryView.js